import styles from "./Address.module.css"
import { MapPinHouse } from 'lucide-react';
import { useTranslation } from "react-i18next";
/**
* Props for the AddressInput component.
*/ 
interface AddressInputProps{
    selectedAddress: string; // Currently selected address
}
/**
* An address input component.
*
* @param props AddressInputProps
* @param {string} props.selectedAddress - Currently selected address
* @returns TSX.Element
*/
const AddressInput = ({ selectedAddress } : AddressInputProps) => {
    const { t } = useTranslation(); // Translation
    return(
        <>
            <div className={styles.AddressInput}>
                <div className={styles.AddressInputHeader}>
                    <div className={styles.AddressInputHeaderIcon}>
                        <MapPinHouse/>
                    </div>
                    <div className={styles.AddressInputHeaderText}>
                        <p className={styles.InputTitle}>{t("checkout.steps.2.inputs.address")}</p>
                        <p className={styles.InputSelected}>{selectedAddress ? selectedAddress : t("checkout.steps.2.inputs.address")}</p>
                    </div>
                </div>
            </div> 
        </>
    )
}


export default AddressInput;
